import { IResponse, fetchData } from '@umu/umu-fetch';
import { API } from '../api';
import { IDepartmentSearchParams, IDepartmentSearchRes, IMemberInfo } from '../interface';
import { defaultDepartmentData } from './defaultData/knowledgePoint';
const getKnowledgePointsDepartmentList = (params: IDepartmentSearchParams): Promise<IDepartmentSearchRes> => {
    return fetchData(API.GET_KNOWLEDGE_DEPARTMENT_LIST, params, { silent: true }).then(
        (res: IResponse<IDepartmentSearchRes>) => {
            return res.data || defaultDepartmentData;
        },
        () => {
            return defaultDepartmentData;
        },
    );
};
const getKnowledgePointsDepartmentSearchList = (name = ''): Promise<IMemberInfo[]> => {
    return fetchData(
        API.GET_KNOWLEDGE_DEPARTMENT_SEARCH_LIST,
        {
            keyword: name,
        },
        { silent: true },
    ).then(
        (res: IResponse<IMemberInfo[]>) => {
            return res.data || [];
        },
        () => {
            return [];
        },
    );
};
export { getKnowledgePointsDepartmentList, getKnowledgePointsDepartmentSearchList };
